import React from "react";
import { Link } from "react-router-dom";

export const ShopFlagship = () => {
  return (
    <section className="bg-[#9E1B50] w-full">
      <div className="w-full px-4 sm:px-8 lg:px-16 py-4 md:py-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center">
          <div className="lg:col-span-5 py-8 lg:py-16">
            <div className="overflow-hidden bg-[#380C1E]/40 aspect-square shadow-xl">
              <img
                src="https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a9477c7c71cb92aeff9c84d.jpg"
                alt="Ieshia Danielle, host of the Becoming Intensive"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          <div className="lg:col-span-7 space-y-5 py-8 lg:py-16">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-white/70 block">
              The Flagship Experience
            </span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-normal text-white leading-tight">
              Becoming Intensive
            </h2>
            <div className="flex items-baseline gap-3 flex-wrap">
              <span className="font-serif text-3xl md:text-4xl font-semibold text-white">
                $997
              </span>
            </div>
            <p className="text-white/85 text-sm md:text-base leading-relaxed font-light max-w-lg">
              A six-week experience with Scripture-rooted teaching, live
              coaching, community, and practical accountability across the six
              areas shaping your life.
            </p>
            <div className="pt-2 flex flex-wrap items-center gap-3">
              <Link
                to="/programs/becoming-intensive"
                className="inline-flex items-center gap-2 bg-white hover:bg-[#FAF6F0] text-[#380C1E] font-bold uppercase text-[11px] tracking-wider px-8 py-4 rounded-full transition-all"
              >
                Explore the Intensive
                <span>→</span>
              </Link>
              <a
                href="https://store.iamieshiadanielle.com/product-details/product/6a99c533a3a2579f28b90d53"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#380C1E] hover:bg-black text-white font-bold uppercase text-[11px] tracking-wider px-8 py-4 rounded-full transition-all"
              >
                Add To Cart
                <span>→</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
